<h2 mat-dialog-title i18n>Session Expired</h2>
<mat-dialog-content i18n>
    Your session has expired. Please log in again to continue.
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="login()" i18n>Log In</button>
</mat-dialog-actions>
